import React, { Component } from 'react';
import Carousel from 'nuka-carousel';

import { Copy, Paragraph } from '../theme';
import { Fridge, Oven, Stove, Washing, Dishwasher } from '../svg';
import { isMobile } from '../util';

import './index.css';

const svg = {
  frigider: Fridge.Repr,
  cuptor: Oven.Repr,
  plita: Stove.Repr,
  rufe: Washing.Repr,
  vase: Dishwasher.Repr
};

export class Slider extends Component {

  constructor(props) {
    super(props);

    this.state = {
      extended: false
    }

  }


  componentDidUpdate = () => {
    if (isMobile && this.state.extended) {
      this.carousel.style.height = document.querySelector('.js__carousel-height').clientHeight + 'px';
    } else {
      this.carousel.style.height = '70px';
    }
  }

  render() {

    const { device } = this.props;
    const arrow = isMobile ? require('../../assets/img/icons/slider-right-white.svg') : require('../../assets/img/icons/slider-right.svg')

    return (
      <div className={`w__carousel ${this.state.extended ? 'extended' : ''}`} ref={(node) => this.carousel = node}>
        <div
          style={{ zIndex: 1005 }}
          className="close"
          onClick={() => this.setState({ extended: false })}
        >
          X
          </div>
        <div onClick={() => this.setState({ extended: true })}><Copy medium> Stiai ca...</Copy></div>
        {svg[device]()}
        <Carousel
          autoplay={true}
          autoplayInterval={15000}
          cellAlign="center"
          renderCenterLeftControls={({ previousSlide }) => (
            <img className="slider-arrow left" onClick={previousSlide} src={arrow} alt="" />
          )}
          renderCenterRightControls={({ nextSlide }) => (
            <img className="slider-arrow right" onClick={nextSlide} src={arrow} alt="" />
          )}
        >
          {this.props.children}
        </Carousel>
      </div>
    );
  }
}

export const Slide = ({ text }) => (
  <div className="slide__item">
    <Paragraph medium>
      {text}
    </Paragraph>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/carousel/index.jsx